export const MAX_TRAINING_SESSIONS = 25;
export const ATTENDANCE_SESSIONS_PER_PAGE = 4;
